import { render, staticRenderFns } from "./proceedsList.vue?vue&type=template&id=7b99952d&scoped=true&"
import script from "./proceedsList.vue?vue&type=script&lang=js&"
export * from "./proceedsList.vue?vue&type=script&lang=js&"
import style0 from "./proceedsList.vue?vue&type=style&index=0&id=7b99952d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b99952d",
  null
  
)

export default component.exports